jQuery(document).ready(function($) {
    modalSteps($);
});

function modalSteps($) {

    const $stepNav = $('.js-step-nav');
    const $steps = $stepNav.find('.js-step');
    const $prev = $stepNav.find('.js-prev');
    const $next = $stepNav.find('.js-next');
    const $submit = $stepNav.find('.js-submit');
    const $stepNumber = $stepNav.find('.js-step-number');
    const $stepTitle = $stepNav.find('.js-step-title');
    const $notice = $stepNav.find('.js-notice');
    const $radioGroups = $stepNav.find('.js-radio-group');


    let activeStep = 1;

    $next.on('click', function() {
        if ( !inputsComplete(activeStep) ) {
            $notice.removeClass('hidden');
            return;
        }
        activeStep++;
        $prev.removeClass('disabled');
        $notice.addClass('hidden');
        $radioGroups.removeClass('required');
        if ( !$steps.filter('[data-step="'+(activeStep+1)+'"]').length ) {
            $next.addClass('hidden');
            $submit.removeClass('hidden');
        }
        changeStep(activeStep);
    });
    $prev.on('click', function() {
        activeStep--;
        $next.removeClass('hidden');
        $submit.addClass('hidden');
        if ( !$steps.filter('[data-step="'+(activeStep-1)+'"]').length ) $prev.addClass('disabled');
        changeStep(activeStep);
    });

    function changeStep(activeStep) {
        $steps.removeClass('active');
        $steps.filter('[data-step="'+activeStep+'"]').addClass('active');
        $stepNumber.html(activeStep);
        $stepTitle.html(stepNavData.stepTitles[activeStep]);
    }

    function inputsComplete(activeStep) {
        const $activeStep = $steps.filter('[data-step="'+activeStep+'"]');
        let error = false;
        $activeStep.find('.js-radio-group').each( function () {
            const $radioGroup = $(this);
            if (!$radioGroup.find('input[type="radio"]:checked').length) {
                console.log('fbnirevibu');
                error = true;
                $radioGroup.addClass('required');
            }
        });
        return !error;
    }

}

